var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75409",
    d: "M8 10c4.8 0 8-3.8 8-5s-3.2-5-8-5C3.3 0 0 3.8 0 5c0 1.1 3.3 5 8 5zm0-1.1c-3.7 0-6.9-3.2-6.9-4 0-.6 3.1-4 6.9-4 3.7 0 6.8 3.3 6.8 4 0 .9-3.1 4-6.8 4zm0-.7A3.311 3.311 0 0011.3 5 3.183 3.183 0 008 1.8 3.244 3.244 0 004.7 5 3.311 3.311 0 008 8.2zm0-2.1A1.11 1.11 0 016.9 5 1.11 1.11 0 018 3.9 1.11 1.11 0 019.1 5 1.11 1.11 0 018 6.1z",
    fill: "#cfcfcf"
  })));
}
export default SvgEye;